'use strict';

var dialog = require('site/dialog'),
	util = require('site/util'),
	page = require('site/page'),
	formPrepare = require('site/pages/checkout/formPrepare');
// linchpin = require('int_googletagmanager/linchpin/dialog')

/*
 * init secure acceptance events
 */

function updateSignatureEmbedded($form, params) {
	var signedFields = $form.find('input[name="signed_field_names"]').val().split(',');
	$.each(signedFields, function (index, value) {
		params[value] = $form.find('input[name="' + value + '"]').val();
	});
	var url = util.appendParamsToUrl(Urls.secureAcceptanceSignature, params);
	$.getJSON(url, function (data) { 
		if (data.success) {
			$form.find('input[name="signature"]').val(data.signature);
			if (data.transaction_uuid) {
				$form.find('input[name="transaction_uuid"]').val(data.transaction_uuid);
			}
			$form.submit();
		} else {
			dialog.open({
				url: Urls.requestErrorMessage,
				options: {
					buttons: [
						{
							text: Resources.GOT_IT,
							click: function () {
								$(this).dialog('close');
							}
						}
					],
					title: Resources.SORRY
				}
			});
		}
	});
}

var initSAEmbeddedIframe = function (data) {
	var $secureAcceptanceForm = $('#secure-acceptance-form');

	if ($secureAcceptanceForm.find('.bill-to-address-state:visible').length > 0) {
		$secureAcceptanceForm.find('input[name="bill_to_address_state"]').val($('.bill-to-address-state:visible').val());
	}

	var params = {};
	/* jshint ignore:start */
	params['merchant_defined_data8'] = $secureAcceptanceForm.find('input[name="merchant_defined_data8"]').val();
	params['csrf_token'] = $secureAcceptanceForm.find('input[name="csrf_token"]').val();
	if (data && data.reinit) {
		params['reinit'] = data.reinit;
	}
	if (data && data.addNewCard) {
		params['addNewCard'] = data.addNewCard;
	}
	if ($secureAcceptanceForm.find('input[name="payer_authentication_acs_window_size"]').length) {
		params['payer_authentication_acs_window_size'] = $secureAcceptanceForm.find('input[name="payer_authentication_acs_window_size"]').val();
	}
	/* jshint ignore:end */
	updateSignatureEmbedded($secureAcceptanceForm, params);
	// GTM Linchpin analytics
	// TODO: what event should be or should be called after iframe has been used
	// linchpin.addNewCard();
};
/**
 * @private
 * @description revalidate invalid field once it becomes visible
 */
var revalidateField = function ($formRow) {
	if ($formRow.find('.error-msg').length > 0) {
		$('#secure-acceptance-form').validate()
		.element($formRow.find('[name$="county_field"]'));
	}
};
function updateStateField (countryCode) {
	var $stateSelectFormRow = $('#secure-acceptance-form .state-select'),
		$stateInputFormRow = $('#secure-acceptance-form .state-input'),
		countryObj = Countries[countryCode];

	if (countryObj && Countries[countryCode].regions) {
		$stateSelectFormRow.show();
		revalidateField($stateSelectFormRow);
		$stateInputFormRow.hide();
		$stateInputFormRow.find('[name$="county_field"]').rules("add", {required: true});
		setStateOptions(countryObj);
	} else {
		$stateInputFormRow.show();
		revalidateField($stateInputFormRow);
		$stateSelectFormRow.hide();
		$stateInputFormRow.find('[name$="county_field"]').rules("remove", "required");
	}
}

function setStateOptions(countryObj) {
	var statesOptions = [];
	statesOptions.push('<option value="">' + countryObj.regionLabel + '</option>');
	var selectedState = $('input[name="bill_to_address_state"]').val();
	for (var r in countryObj.regions) {
		if (selectedState === r) {
			statesOptions.push('<option selected="selected" value="' +  r + '">' + countryObj.regions[r] + '</option>');
		} else {
			statesOptions.push('<option value="' +  r + '">' + countryObj.regions[r] + '</option>');
		}
	}
	$('#bill-to-address-state-select').html(statesOptions);
	$('#bill-to-address-state-select').trigger('change');
}


function updatePostFieldPlaceholder(countryCode) {
	var countryObj =  Countries[countryCode],
		$postField = $('#secure-acceptance-form').find('[name$="postal_code"]');

	if (countryObj && countryCode === 'GB' && countryObj.postalLabel) {
		$postField.attr('placeholder', countryObj.postalLabel);
	} else {
		$postField.attr('placeholder', Resources.ZIPCODE_UNIVERSAL_LABEL);
	}
}

var saEmbedded = {
	init: function (params) {
		const isAddNewCard = params && params.addNewCard;
		const isReInit = params && params.reinit;
		if (isAddNewCard || (isAddNewCard && isReInit)) {
			formPrepare.init({
				continueSelector: '#secure-acceptance-submit',
				formSelector: '#secure-acceptance-form',
				replaceInvalidInput: true,
				keyup: false,
				autofillValidate: true
			});
		
			$('#bill-to-address-country').on('change', function () {
				var countryCode = $('#bill-to-address-country').val();
				$('input[name="bill_to_address_country"]').val(countryCode);
				updateStateField(countryCode);
				updatePostFieldPlaceholder(countryCode);
			});
			updateStateField($('#bill-to-address-country').val());
			updatePostFieldPlaceholder($('#bill-to-address-country').val());
		}

		initSAEmbeddedIframe(params);
		if (isReInit) {
			return;
		}

		$('iframe[name="step-up-iframe"]').on('load', function () {
			console.log('iframe src on load:', $(this));
			var iframe = $(this);
		});
		if (!isAddNewCard) {
			$(document).on('reEntryEmbedded', function(e) {
				const detail = e.originalEvent.detail;
				let location = detail.location;
				var params = {
					'embeddedStatusSuccess': detail.embedded_status_success
				}
				if (detail.basket_not_found !== 'null') {
					params.BasketNotFound = detail.basket_not_found;
				}
				if (detail.email !== 'null') {
					params.email = detail.email;
				}
				if (detail.PlaceOrderError !== 'null') {
					params.PlaceOrderError = detail.PlaceOrderError;
				}
				const returnURLUpdated = util.appendParamsToUrl(location, params);

				page.redirect(returnURLUpdated);
			});
			return;
		}
		$(document).on('walletReentryEmbedded', function(e) {
			const detail = e.originalEvent.detail;
			let location = detail.location;
			var params = {
				'embeddedStatusSuccess': detail.embedded_status_success
			}
			const returnURLUpdated = util.appendParamsToUrl(location, params);
			page.redirect(returnURLUpdated);
		});
	}
};

$(document).on('reinitforsavecard', function(each){
	saEmbedded.init({'reinit': true});
});

module.exports = saEmbedded;
